// extracted by mini-css-extract-plugin
export default {"cls1":"F73vJuI6i6mPmffCD2gV","cls2":"H4WPtEXiC0uxkhL35Ttw F73vJuI6i6mPmffCD2gV"};